<template>
  <div class="empty" >
    <div class="message-empty">
      <div class="message-empty__img">
        <img src="../../assets/empty.svg" alt="">
      </div>
      <div class="message-empty--text">
        <p>No download gates have been created yet</p>
        <router-link :to="'/new-gate'">
          <button>
            Create your first gate
          </button>
        </router-link>
      </div>
    </div>
  </div>
</template>
<style scoped lang="sass">
.empty
  display: flex
  flex-direction: row
  align-items: center
  justify-content: center
  margin-top: 50px
  .message-empty
    display: flex
    flex-direction: row
    align-items: center
    width: 480px
    &__img
      width: 150px
      height: 95px
      margin: 20px
      display: flex
    &--text
      width: 280px
      p
        padding: 0 0 20px 0
        font-size: 0.9rem
      a
        button
          color: #454545
          border: 1px solid #9a9a9a
          font-weight: 600
          font-size: 13px
          width: 210px
          height: 34px
          text-transform: uppercase
          background: #fff
          &:hover
            background: #efefef
</style>
<script>
export default {
  name: 'EmptyMessage',
  components: {},
  data() { return {}},
  methods: {}
}
</script>